import { SolicitationData } from '../types/solicitation';

export interface ParsedSolicitationData {
  title: string;
  description: string;
  highlights: string[];
  dates: Array<{ date: Date; description: string }>;
  requirements: string[];
  attachments: Array<{ name: string; url: string; type: string }>;
  contacts: Array<{ name: string; email: string; phone: string }>;
  location: {
    address?: string;
    city?: string;
    state?: string;
    country?: string;
  };
}

export function parseSolicitationData(data: SolicitationData): ParsedSolicitationData {
  return {
    title: data.title || '',
    description: data.description || '',
    highlights: data.technicalDetails?.requirements || [],
    dates: data.timeline?.importantDates?.map(d => ({
      date: d.date,
      description: d.description
    })) || [],
    requirements: data.technicalDetails?.requirements || [],
    attachments: data.attachments?.map(a => ({
      name: a.name,
      url: a.url,
      type: a.type
    })) || [],
    contacts: data.contacts ? [
      data.contacts.primary,
      data.contacts.secondary,
      data.contacts.contracting
    ].filter(Boolean).map(c => ({
      name: c!.name,
      email: c!.email,
      phone: c!.phone
    })) : [],
    location: {
      address: data.location?.placeOfPerformance?.address,
      city: data.location?.placeOfPerformance?.city,
      state: data.location?.placeOfPerformance?.state,
      country: data.location?.placeOfPerformance?.country
    }
  };
}
